{
  "en": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Details",
          "reminder": "Reminders"
        },
        "closeAllRows": "Close all rows",
        "deleteCount": "You are about to delete {count} installment. Are you sure? | You are about to delete {count} installments. Are you sure?",
        "delete_installments": "Delete installment | Delete installments",
        "edit": "Edit",
        "newInstallment": "New Installment Term",
        "openAllRows": "Open all rows",
        "publish": "Publish",
        "publishCustomer": "Publish...",
        "save": "Update",
        "unpublish": "Unpublish",
        "updateStatus": "Update status",
        "uploadInvoice": "Upload invoice"
      },
      "attributes": {
        "amount": "Amount",
        "customer": "Customer",
        "description": "Description",
        "due_date": "Deadline",
        "group_name": "Installment term",
        "paid_at": "Paid at",
        "status_deadline": "Status",
        "unit": "Unit"
      },
      "edit_actions": {
        "edit_amount": "Amounts",
        "edit_deadline": "Deadline",
        "edit_description": "Description",
        "edit_status": "Status"
      },
      "labels": {
        "cantEditFractions": "Set the installment status to 'Draft' to edit the rules.",
        "changeStatusRequested": "Change Installments from status 'Draft' to 'Invoiced'",
        "changeVisibility": "Change visibility...",
        "change_amounts": "Change amounts",
        "clear_due_date": "Clear due date for all selected installments",
        "clear_paid_at": "Clear paid at date for all selected installments",
        "countEdit": "Editar prestação para 1 unidade | Editar prestação para {count} unidades",
        "created_at": "Created {created_at}",
        "deleteExplanation": "All installments and invoices will be permanently removed from the platform.",
        "deleteExplanationGroup": "Because you want to remove all installments in this installment group, the installment group will be removed as well.",
        "details": "Details",
        "edit": "Edit installments",
        "editDueDate": "Edit deadline",
        "editInstallmentTerm": "Edit installment",
        "excl_vat": "excl. VAT",
        "giveNewAmount": "Give in new amount",
        "goToUnitInstallments": "Go to unit installments",
        "installmentNoteExplainer": "This note is only visible to team members.",
        "installment_categories": "Custom categories",
        "invoices": "1 invoice | {count} invoices",
        "new_installment_fraction_category": "Category",
        "noDeadline": "No deadline",
        "notPublished": "Not published",
        "paid": "Paid",
        "published": "Published",
        "publishedCustomer": "Published for customer",
        "publishingForCustomers": "Are you sure?",
        "selectOne": "Select at least 1 installment",
        "selected": "{selected} installment selected. | {selected} installments selected.",
        "setDueDate": "Set deadline",
        "statusExplained": "What does each installment status mean?",
        "status_click_to_change": "Click to change",
        "status_deadline": "Status",
        "statuses": {
          "draft": "Draft",
          "expected": "Expected",
          "overdue": "Overdue",
          "paid": "Paid",
          "requested": "Invoiced"
        },
        "toBePaid": "To be paid",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "Unit installments will be shown here",
        "unpublishingForCustomers": "Unpublishing installments for the customer. Are you sure?",
        "updateStatusCount": "Update status for 1 installment | Update status for {count} installments",
        "uploadInvoiceCount": "Upload invoice for 1 installment | Upload invoice for {count} installments",
        "uploadInvoiceUnit": "Upload invoice to {unit_name}",
        "vat": "VAT",
        "vat_with_percentage": "{percentage}% VAT",
        "view_list": "List"
      },
      "legend": {
        "installmentDraft": "Draft installment",
        "installmentDraftAfterDueDate": "Draft installment",
        "installmentExpired": "Deadline expired",
        "installmentPaid": "Installment already paid",
        "installmentPaidAfterDue": "Installment paid after deadline",
        "installmentRequested": "Invoiced",
        "reminders": {
          "active": "At least 1 reminder has been set",
          "none": "No reminders have been set"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "All installment documents will be shown here.",
            "title": "No documents yet!"
          },
          "new": {
            "subtitle": "New installments will come soon!"
          }
        }
      },
      "sort_options": {
        "due_date": "Prazo de entrega",
        "due_date asc": "Prazo mais distante primeiro",
        "due_date desc": "Prazo mais próximo primeiro",
        "group_name": "Nome",
        "group_name asc": "Nome A-Z",
        "group_name desc": "Nome Z-A",
        "status": "Estado",
        "status asc": "Estado A-Z",
        "status desc": "Estado Z-A",
        "updated_at asc": "A atualização mais recente primeiro",
        "updated_at desc": "Primeira atualização mais recente"
      },
      "validation": {
        "needNumber": "Need a number (e.g. 8400.5)"
      }
    }
  }
}
